import { LoadingStatusType } from "@/enums/enums";
import { i18n } from "@/i18n";
import { ToAccountList } from "@/service/account/accountFacade";
import API from "@/service/Index";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";

@Module({ namespaced: true })
export default class Account extends VuexModule {
  public accountListLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public accountList: any = [];
  public accountMap: Map<number, any> = new Map<number, any>();

  get getAccountListLoadingStatus(): any {
    return this.accountListLoadingStatus;
  }

  get getAccountList(): any {
    return this.accountList;
  }
  get getAccountMap(): Map<number, any> {
    return this.accountMap;
  }

  @Mutation
  public MutationSetAccountListLoadingStatus(status: LoadingStatusType) {
    this.accountListLoadingStatus = status;
  }

  @Mutation
  public MutationSetAccountList(accountList: any) {
    this.accountList = accountList;
    this.accountMap = new Map<number, any>();
    if (accountList && accountList.length > 0) {
      for (const account of accountList) {
        this.accountMap.set(account.id, account);
      }
    }
  }

  @Action
  public DoGetAllMainAccount() {
    if (this.accountListLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationSetAccountListLoadingStatus", LoadingStatusType.Loading);
      API.AccountService.DoGetAllMainAccount()
        .then((res) => {
          if (res.data.responseCode.IsSuccess()) {
            const accountList = ToAccountList(res.data.accountList, i18n.locale);
            this.context.commit("MutationSetAccountList", accountList);
          }
          this.context.commit("MutationSetAccountListLoadingStatus", LoadingStatusType.Success);
        })
        .catch((error) => error);
    }
  }
}
